export default function hasPerm (item) {
  let perm = JSON.parse(sessionStorage.getItem('authoritys'))
  return perm.indexOf(item) > -1
}



// WEBPACK FOOTER //
// ./src/javascript/hasPermJs.js